import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Datagrid from "../../components/Datagrid/Datagrid";
import { useSite } from "../../context/siteContext";
import customHttp from "../../services/customHTTP";
import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Link,
	Modal,
	Tab,
	Tabs,
	Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useCart } from "../../context/cartContext";
import { ASSETS_BASE_URL } from "../../config";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailIcon from "@mui/icons-material/Email";
import RequestsHistory from "../../components/RequestsHistory/RequestsHistory";
import QuantityTable from "../../components/QuantityTable/QuantityTable";

const Requests = () => {
	const [availableToPurchaseList, setAvailableToPurchaseList] = useState([]);
	const [requestList, setRequestList] = useState([]);
	const [loading, setloading] = useState(true);
	const [selectedRLRows, setSelectedRLRows] = useState([]);
	const [selectedATCRows, setSelectedATCRows] = useState([]);
	const [buttonLoading, setButtonLoading] = useState(false);
	const [buttonSuccess, setButtonSuccess] = useState(false);
	const [error, setError] = useState("");
	const { selectedSite, selectedSiteData, selectedSiteCurrency } = useSite();
	const navigate = useNavigate();
	const { user } = useAuth();
	const [activeTab, setActiveTab] = useState(0);
	const { addMultipleToCart } = useCart();
	const [modalOpen, setModalOpen] = useState(false);
	const [modalLoading, setModalLoading] = useState(false);
	const [rlData, setRlData] = useState([]);
	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "65%",
		bgcolor: "background.paper",
		boxShadow: 24,
		borderRadius: 2,
		p: 2,
		px: 4,
	};

	const fetchReqList = async () => {
		const req_body = {
			site_number: selectedSite,
		};

		try {
			const response = await customHttp.post("/request_list/bysiteid", req_body);
			if (response.data.success) {
				const products = response.data.data;
				console.log("Request List Products: ", products);
				const purchasableProducts = products
					.filter((product) => product.productData.purchasable === 1)
					.map((product) => {
						const item = product.productData;
						const key = `price_${selectedSiteCurrency}`;
						const currencyPrice = item[key];
						const finalPrice = item.purchasable ? currencyPrice : 0;
						return {
							product_id: item.product_id,
							product_name: item.product_name,
							product_number: item.product_number,
							machine_id: product.machine_id,
							machine_number: product.machineData.machine_number,
							product_price: finalPrice,
						};
					});

				const nonPurchasableProducts = products
					.filter((product) => product.productData.purchasable === 0)
					.map((product) => {
						const item = product.productData;
						const key = `price_${selectedSiteCurrency}`;
						const currencyPrice = item[key];
						const finalPrice = item.purchasable ? currencyPrice : 0;
						return {
							product_id: item.product_id,
							product_name: item.product_name,
							product_number: item.product_number,
							machine_id: product.machine_id,
							machine_number: product.machineData.machine_number,
							product_price: finalPrice,
						};
					});

				setRequestList(nonPurchasableProducts);
				setAvailableToPurchaseList(purchasableProducts);
				setloading(false);
			}
		} catch (error) {
			console.error("Error fetching Request List:", error);
			setError(error);
		}
	};

	useEffect(() => {
		if (selectedSite !== "") fetchReqList();
	}, [selectedSite]);

	const handleRowSelect = (rows) => {
		setSelectedRLRows(rows);
	};

	const handleRowSelectPurch = (rows) => {
		setSelectedATCRows(rows);
	};

	const handleDeleteSelected = async () => {
		if (selectedRLRows.length === 0) {
			setButtonLoading(false);
			// Show alert if no users are selected
			Swal.fire({
				icon: "warning",
				title: "No Products Selected",
				text: "Please select products to remove from Request List.",
			});
			return;
		}
		const selectedRowsData = selectedRLRows.map((id) => {
			return requestList.find((row) => row.product_id === id);
		});
		const req_body = {
			selected_rows: selectedRowsData,
			selectedSite,
		};
		console.log(req_body);
		try {
			const response = await customHttp.post("/request_list/delete", req_body);
			if (response.data.success) {
				setRequestList((prevList) => prevList.filter((row) => !selectedRLRows.includes(row.product_id)));
				// Reset selection
				setSelectedRLRows([]);
				Swal.fire({
					title: "Sucess!",
					text: "Part(s) Removed from Request List",
					icon: "success",
				});
			}
		} catch (error) {
			console.error("Error deleting from Request List:", error);
			setError(error);
		}
	};

	const handleNotifyCC = async () => {
		if (selectedRLRows.length === 0) {
			setButtonLoading(false);
			// Show alert if no users are selected
			Swal.fire({
				icon: "warning",
				title: "No Products Selected",
				text: "Please select products to notify.",
			});
			return;
		}

		setModalOpen(true);
		setModalLoading(true);
		const selectedRowsData = selectedRLRows.map((id) => {
			const row = requestList.find((row) => row.product_id === id);
			return {
				...row,
				quantity: row?.quantity ?? 1, // default to 1 if quantity is undefined
			};
		});
		console.log(selectedRowsData);
		setRlData(selectedRowsData);
		// setButtonLoading(true);
		// // Check if any rows are selected

		// console.log(selectedRowsData);

		// Confirm deletion if users are selected
	};

	const handleRequestListSubmit = async () => {
		setButtonLoading(true);
		console.log("RL Data: ", rlData);
		const req_body = {
			selected_rows: rlData,
			selectedSite,
			selectedSiteName: selectedSiteData.customer_site_name,
			selectedSiteId: selectedSiteData.site_id,
			user_name: user.user_display_name,
			user_email: user.user_email,
			user_phone: user.user_phone,
			user_id: user.user_id,
			shipping_address: selectedSiteData.address_full_ln,
			user_id: user.user_id,
			selectedSiteId: selectedSiteData.site_id,
		};

		try {
			const response = await customHttp.post("/request_list/notifycc", req_body);
			if (response.data.success) {
				setModalOpen(false);
				setModalLoading(false);
				setButtonLoading(false);
				setButtonSuccess(true);
				await fetchReqList();
				Swal.fire({
					title: "Sucess!",
					text: "Notified Customer Care",
					icon: "success",
				});
			} else if (!response.data.success) {
				console.log("Axios Error");
				setButtonLoading(false);
				setButtonSuccess(false);
				setModalOpen(false);
				setModalLoading(false);
				Swal.fire({
					title: "Error",
					text: "There was an Unexpected error sending the Email",
					icon: "error",
				});
			}
		} catch (error) {
			console.error("Error fetching Request List:", error);
			setError(error);
			setButtonLoading(false);
			setButtonSuccess(false);
			setModalOpen(false);
			setModalLoading(false);
			Swal.fire({
				title: "Error",
				text: "There was an Unexpected error sending the Email",
				icon: "error",
			});
		}

		setTimeout(() => {
			setButtonSuccess(false);
		}, 3000);
	};

	const handleCloseDialog = () => {
		setModalOpen(false);
		setModalLoading(false);
	};

	const handleAddtoCart = async () => {
		// Check if any rows are selected
		if (selectedATCRows.length === 0) {
			// Show alert if no users are selected
			Swal.fire({
				icon: "warning",
				title: "No Products Selected",
				text: "Please select products to add to cart.",
			});
			return;
		}
		const purchasableProducts = [];
		selectedATCRows.forEach((productId) => {
			const product = availableToPurchaseList.find((product) => product.product_id === productId);
			if (product) {
				const productEntry = {
					product_id: product.product_id,
					Quantity: 1,
					Site: selectedSite,
				};
				purchasableProducts.push(productEntry);
			}
		});
		if (purchasableProducts.length > 0) {
			await addMultipleToCart(purchasableProducts);
			Swal.fire({
				title: "Sucess!",
				text: "Products Added to Cart",
				icon: "success",
			});
		}
		// Confirm deletion if users are selected
	};

	var customButtons = [
		{
			label: buttonLoading ? <>Sending Email</> : buttonSuccess ? <>Sent</> : "Request Price",
			onClick: () => {
				handleNotifyCC();
			},
			icon: buttonLoading ? (
				<>
					<CircularProgress size={16} sx={{ color: "white" }} />
				</>
			) : buttonSuccess ? (
				<>
					<CheckCircleIcon sx={{ color: "white" }} />
				</>
			) : (
				<EmailIcon />
			),
		},
	];

	if (user.user_role !== "Viewer") {
		customButtons = [
			...customButtons,
			{
				label: "Remove Selected",
				onClick: () => {
					handleDeleteSelected();
				},
				icon: <DeleteIcon />,
			},
		];
	}

	const customButtonsPurch = [
		{
			label: "Add to Cart",
			onClick: () => {
				handleAddtoCart();
			},
		},
	];

	const columns = [
		{
			field: "product_name",
			headerName: "Part Name",
			flex: 1,
			renderCell: (params) => {
				const defaultImage = `${ASSETS_BASE_URL}/stock.png`;

				const handleError = (e) => {
					e.target.onerror = null; // Prevent infinite loop
					e.target.src = defaultImage; // Fallback to default image
				};

				const src = `${ASSETS_BASE_URL}/ProductImages/TMB/${params.row.product_number}.png`;

				return (
					<div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-start" }}>
						<img
							src={src}
							alt={params.row.product_name}
							onError={handleError}
							style={{
								width: "40px",
								height: "40px",
								objectFit: "cover",
								borderRadius: "4px",
							}}
						/>
						<div>
							<Link
								sx={{ cursor: "pointer" }}
								variant="body2"
								onClick={() => {
									navigate(`/machines/${params.row.machine_id}/${params.row.product_id}`);
								}}>
								{params.row.product_name}
							</Link>
						</div>
					</div>
				);
			},
		},
		{ field: "product_number", headerName: "Part #", width: 300 },
		{ field: "machine_number", headerName: "Machine" },
	];

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	// if (error) {
	//     return (
	//         <Alert severity="error" className="error-alert">
	//             {error}
	//         </Alert>
	//     );
	// }

	return (
		<div className="order-history-container">
			<PageTitle title="Requests" />

			{/* Tabs for switching between Request List and Available to Purchase */}
			<Tabs
				value={activeTab}
				onChange={handleTabChange}
				aria-label="Order History Tabs"
				className="order-history-tabs">
				<Tab label="Request List" />
				<Tab label="Available to Purchase" />
				<Tab label="History" />
			</Tabs>

			{/* Conditionally render content based on the selected tab */}
			{activeTab === 0 && (
				<>
					{requestList.length === 0 && !loading ? (
						<Alert severity="info" className="error-alert" sx={{ marginTop: "10px" }}>
							No Products in the Request List
						</Alert>
					) : (
						<Datagrid
							key="product_id"
							data={requestList}
							columns={columns}
							rowClick={false}
							pageSize={10}
							showSearchBar={true}
							checkboxSelection={true}
							customButtons={customButtons}
							onSelect={handleRowSelect}
							rowIdField="product_id"
							sortBy={[{ field: "product_name", sort: "asc" }]}
						/>
					)}
				</>
			)}

			{activeTab === 1 && (
				<>
					{availableToPurchaseList.length === 0 && !loading ? (
						<Alert severity="info" className="error-alert" sx={{ marginTop: "10px" }}>
							No Products Available to Purchase
						</Alert>
					) : (
						<Datagrid
							key="product_id"
							data={availableToPurchaseList}
							columns={columns}
							rowClick={false}
							pageSize={5}
							showSearchBar={true}
							checkboxSelection={true}
							customButtons={customButtonsPurch}
							onSelect={handleRowSelectPurch}
							rowIdField="product_id"
							sortBy={[{ field: "purchase_name", sort: "asc" }]}
						/>
					)}
				</>
			)}
			{activeTab === 2 && (
				<>
					<RequestsHistory />
				</>
			)}

			<Modal
				open={modalOpen}
				onClose={handleCloseDialog}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description">
				<Box sx={style}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							alignItems: "center",
							mb: 2,
							mt: 1,
						}}>
						<Box>
							<Typography variant="h5" sx={{ m: 0, fontWeight: "bold" }}>
								Request List{" "}
							</Typography>
							<Typography variant="body1" sx={{ m: 0 }}>
								Modify the request parts quantity
							</Typography>
						</Box>
						<IconButton aria-label="close" onClick={handleCloseDialog}>
							<CloseIcon />
						</IconButton>
					</Box>
					<Box
						sx={{
							flexWrap: "wrap",
							maxHeight: "60vh",
							overflowY: "auto",
						}}>
						<QuantityTable data={rlData} setData={setRlData} />
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "center",
							alignItems: "center",
							my: 2,
							columnGap: "10px",
						}}>
						<Button
							variant="contained"
							onClick={handleRequestListSubmit}
							startIcon={
								buttonLoading ? (
									<>
										<CircularProgress size={16} sx={{ color: "white" }} />
									</>
								) : buttonSuccess ? (
									<>
										<CheckCircleIcon sx={{ color: "white" }} />
									</>
								) : (
									<EmailIcon />
								)
							}>
							{buttonLoading ? "Sending Email" : buttonSuccess ? "Sent" : "Request Price"}
						</Button>
						<Button variant="outlined" onClick={handleCloseDialog}>
							Cancel
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default Requests;
